import { useSyncExternalStore } from 'react';

/**
 * Включён ли фоновый плеер на этой вкладке.
 *
 * Сам плеер (единственный `<audio>` и всё, что к нему привязано) стоит в
 * общем layout локали, выше и витрины aisearch, и кабинета: только там он
 * не перемонтируется при переходе сайт ↔ кабинет, и музыка не
 * прерывается. Но этот layout общий и для ingdg.com с datahunter.store,
 * а продукт в нём неизвестен: заголовки запроса там читать нельзя, это
 * лишило бы предварительной сборки все страницы.
 *
 * Поэтому плеер включают ветки, которые продукт знают: layout витрины
 * aisearch и кабинет на домене aisearch (панель `FonPleerPanel`). Пока
 * никто не включил, общий layout не рисует ничего и не грузит код
 * плеера — на чужих доменах так и остаётся.
 *
 * Включение не снимается до перезагрузки: при переходе витрина →
 * кабинет одна панель уходит раньше, чем приходит другая, и выключение
 * в этот момент остановило бы музыку. С aisearch на другой продукт
 * клиентского перехода нет — это другой домен.
 */
export interface Vklyuchatel {
  vklyuchit: () => void;
  vklyuchen: () => boolean;
  podpisatsya: (fn: () => void) => () => void;
}

export function sozdatVklyuchatel(): Vklyuchatel {
  let on = false;
  const slushateli = new Set<() => void>();
  return {
    vklyuchit: () => {
      if (on) return;
      on = true;
      for (const fn of slushateli) fn();
    },
    vklyuchen: () => on,
    podpisatsya: (fn) => {
      slushateli.add(fn);
      return () => {
        slushateli.delete(fn);
      };
    },
  };
}

const vkladka = sozdatVklyuchatel();

/** Включить фоновый плеер на вкладке. Повторный вызов ничего не делает. */
export function vklyuchitFonPleer(): void {
  vkladka.vklyuchit();
}

const vyklyuchenNaServere = () => false;

/** Включён ли плеер. На сервере — нет: в HTML плеера не бывает ни на одном домене. */
export function useFonPleerVklyuchen(): boolean {
  return useSyncExternalStore(vkladka.podpisatsya, vkladka.vklyuchen, vyklyuchenNaServere);
}
